var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAccepted || (_vm.canAccept && !_vm.isTop))?_c('div',{class:_vm.isAccepted ? 'f-icon-accept' : 'f-icon-accept-not',on:{"click":_vm.accept}},[_vm._v(" "+_vm._s(_vm.tip)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }